import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

// Create a new app conversation
export const createAppConversation = async (appData) => {
  const response = await fetch(`${API_BASE_URL}/api/apps/conversations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(appData),
  });
  
  if (!response.ok) {
    throw new Error('Failed to create app conversation');
  }
  
  return response.json();
};

// Get app conversation by ID
export const getAppConversation = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/apps/conversations/${id}`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch app conversation');
  }
  
  return response.json();
};

// Update app conversation (e.g., system prompt)
export const updateAppConversation = async (id, updates) => {
  const response = await fetch(`${API_BASE_URL}/api/apps/conversations/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(updates),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update app conversation');
  }
  
  return response.json();
};

// Get all app conversations
export const getAppConversations = async () => {
  const response = await fetch(`${API_BASE_URL}/api/apps/conversations`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch app conversations');
  }
  
  return response.json();
};